import { MailboxFolderEnums, NotificationSortEnums, SortDirectionEnums } from 'src/shared/enums';
import { IMapperRecord } from 'src/shared/utils';

import { NotificationsColumnEnums } from './MessageCenterList.enums';

export const defaultNotificationsFilters = {
  mailboxFolder: MailboxFolderEnums.IN,
  sortBy: NotificationSortEnums.DATE,
  sortDirection: SortDirectionEnums.DESCENDING,
};

export const mapNotificationsSortByToColumnEnums: IMapperRecord<NotificationsColumnEnums> = {
  [NotificationSortEnums.SENDER]: NotificationsColumnEnums.SENDER,
  [NotificationSortEnums.SUBJECT]: NotificationsColumnEnums.SUBJECT,
  [NotificationSortEnums.DATE]: NotificationsColumnEnums.DATE,
};
